export function parseSchemaJson(content: string, filePath: string): unknown {
  try {
    return JSON.parse(content)
  } catch {
    throw new Error(`Failed to parse JSON schema: ${filePath}`)
  }
}
